import React, { PureComponent } from "react";
import * as PropTypes from "prop-types";
import moment from "moment";
import { Button, Col, Label, Row } from "reactstrap";
import LabeledValue from "./LabeledValue";
import EnumState from "../api/gen/qsign/types/EnumState";
import * as appUtils from "../utils/appUtils";
import { Icon } from "@mc/mc-legacy";
import SignRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import SeznamPriloh from "./SeznamPriloh";
import { Modal } from "@mc/react-core";

/**
 * Meta informace o dokumentu požadavku
 */

class SignRequestDocumentData extends PureComponent {
  static propTypes = {
    requestDocument: PropTypes.object.isRequired,
  };
  formatDate = (date) => {
    return moment(date).format("DD.M.YYYY");
  };

  renderSignedOrRejected = () => {
    const requestDocument: SignRequestDocumentVO = this.props.requestDocument;

    if (requestDocument.state === EnumState.REJECTED) {
      return (
        <LabeledValue
          label="Odmítnuto"
          value={requestDocument.rejected ? this.formatDate(requestDocument.rejected) : "-"}
        />
      );
    } else if (requestDocument.state === EnumState.SIGNED) {
      return (
        <LabeledValue
          label="Podepsáno"
          value={requestDocument.signed ? this.formatDate(requestDocument.signed) : "-"}
        />
      );
    }

    return null;
  };

  render() {
    const requestDocument: SignRequestDocumentVO = this.props.requestDocument;
    let podepisujici = requestDocument.pracovnikSignList.map((pracovnik) => appUtils.getPracovnikLabel(pracovnik));
    podepisujici = podepisujici.join(", ");
    if (requestDocument.state === EnumState.ERROR) {
      return (
        <Row noGutters className={"mt-2 w-100 h-100"}>
          <Col xs={12}>
            <Label color={"red"}>{requestDocument.errorMessage}</Label>
          </Col>
        </Row>
      );
    }

    return (
      <Row noGutters className={"mt-2 w-100"}>
        <Col xs={6} md={3}>
          <LabeledValue label="Předloženo" value={this.formatDate(requestDocument.created)} />
        </Col>
        <Col xs={6} md={3}>
          <LabeledValue label="Předkladatel" value={appUtils.getPracovnikLabel(requestDocument.pracovnikRequest)} />
        </Col>
        <Col xs={6} md={3}>
          {this.renderSignedOrRejected()}
        </Col>
        <Col xs={6} md={3}>
          <LabeledValue label="Podepisující" value={podepisujici} />
        </Col>
      </Row>
    );
  }
}

export default SignRequestDocumentData;
